module.exports = __webpack_public_path__ + "img/download-btn-11022022.bd69c40e.svg";